export default __webpack_public_path__ + "static/media/quiz-promo.40de3035.jpg";